import gql from 'not-graphql-tag';

export const getAccountDetailsForPaymentExtension = gql`
  query getAccountDetails(
    $params: AccountDetailParams!) {
    getAccountDetails(params: $params) {     
      paymentExtensionInfo {
        eligibility
        currentPlan {
          amountDue
          dueDate
          planId
          enrolledInOption3
        }
        paymentExtensionOptions {
          paymentExtensionOptionType
          amount
          planDate
        }
        isEnrolled
      }    
    }
  }
`;

export const createPaymentExtensionMutation = gql`
  mutation enrollPaymentExtension($payload: PaymentExtensionEnrollInput!) {
    enrollPaymentExtension(payload: $payload) {
      confirmationNumber
    }
  }
`;
